import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate, useParams } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import LandingPage from './pages/landing-page';
import TryDepthMeBeta from './pages/try-depth-me-beta-page';
import MainAppHomePage from './pages/main-app-home-page';
import PrivacyPage from './pages/privacy';
import TermsPage from './pages/terms';
import ContactPage from './pages/contact';
import FunnelPage from './pages/funnel';

function StartRedirect() {
  const { variant } = useParams();
  return <Navigate to={`/mindrest/${variant}`} replace />;
}

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<MainAppHomePage />} />
        <Route path="/landing-page" element={<LandingPage />} />
        <Route path="/beta" element={<TryDepthMeBeta />} />
        <Route path="/main" element={<MainAppHomePage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/contact" element={<ContactPage />} />
        {/* The ad funnel. /start redirects here (vercel.json); the in-app
            <Navigate> covers local dev and any client-side link. */}
        <Route path="/mindrest" element={<FunnelPage />} />
        <Route path="/mindrest/:variant" element={<FunnelPage />} />
        <Route path="/start" element={<Navigate to="/mindrest" replace />} />
        <Route path="/start/:variant" element={<StartRedirect />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;